// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { Amount, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const titleStyles = (breakpoints: Array<Amount | null>) => css`
    ${spacingStyles("1em", "0.5em")}
    ${breakpointValues(pxToRemArray(breakpoints), "font-size")}
    color: ${getColor("text")}; /* Store Custom Code */
    font-weight: ${x => x.theme.design.typography.weight.bold};
`;

const typography: Styleguide["typography"] = {
    fontFamilyImportUrl: "", // ${constants.path.fonts}/common.css
    body: {
        size: "inherit",
        weight: "inherit",
        fontFamily: "inherit",
        css: css`
            ${({ theme }) => `
                font-weight: ${theme.design.typography.weight.base};
                font-family: ${theme.design.typography.fontFamily.base};
                font-size: ${theme.design.typography.size.base};
                line-height: ${theme.design.typography.lineHeight.base};
            `}
        `,
    },
    p: {
        size: "inherit",
        weight: "inherit",
        css: css`
            ${spacingStyles()}
        `,
    },
    h1: {
        css: css`
            ${titleStyles([null, 31, 37, null, 48])}
            line-height: ${x => x.theme.design.typography.lineHeight.small};
        `,
    },
    h2: {
        css: css`
            ${titleStyles([null, null, 31, null, 36])}
            line-height: ${x => x.theme.design.typography.lineHeight.small};
        `,
    },
    h3: {
        css: css`
            ${titleStyles([null, null, 23, null, 28])}
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    h4: {
        css: css`
            ${titleStyles([null, null, 18, null, 20])}
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    h5: {
        css: css`
            ${titleStyles([null, null, null, null, 16])}
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    h6: {
        css: css`
            ${titleStyles([null, null, null, null, 12])}
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    legend: {
        css: css`
            color: ${getColor("text.accent")};

            ${({ theme }) => `
                font-size: ${theme.design.typography.size.tiny};
                font-weight: ${theme.design.typography.weight.bold};
                line-height: ${theme.design.typography.lineHeight.base};
            `}
        `,
    },
};

export default typography;
